<template>
  <el-form-item
    :label="`${$t('ORGANIZATIONS') || 'Organizations'}`"
    prop="organizations"
    v-loading="organizationsLoading"
    element-loading-spinner="el-icon-loading"
  >
    <el-select
      :disabled="ruleForm.disabled"
      v-model="ruleForm.organizations"
      clearable
      @change="$emit('organizations', ruleForm.organizations)"
      @clear="$emit('clear')"
      @blur="$emit('blur')"
      @visible-change="handleVisibleChange"
      multiple
      collapse-tags
      filterable
      :placeholder="$t('SELECT_PLACEHOLDER')"
      :no-data-text="$t('NO_RESULT')"
    >
      <el-option
        v-for="item in organizationsList"
        :key="item.id + Math.random()"
        :label="
          $i18n.locale == 'fa'
            ? item.fa_title || item.title
            : item.en_title || item.title
        "
        :value="item.id"
      ></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { organizationSummaryList } from '@/api/acl'

export default {
  props: ['value'],
  data() {
    return {
      ruleForm: {
        organizations: [],
      },
      organizationsList: [],
      organizationsLoading: true,
    }
  },

  methods: {
    handleVisibleChange(visible) {
      // When dropdown closes (visible becomes false), emit blur event
      if (!visible) {
        this.$emit('blur')
      }
    },
  },

  created() {
    organizationSummaryList.api().then((res) => {
      if (res) {
        this.organizationsList = res.sort((a, b) => {
          const nameA = a.title?.toLowerCase() || ''
          const nameB = b.title?.toLowerCase() || ''
          return nameA.localeCompare(nameB)
        })
        this.organizationsLoading = false
      }
    })
  },

  watch: {
    value(val) {
      if (!val || !Array.isArray(val) || (val.length === 1 && val[0] === ''))
        return

      const numberArray = val.map(Number)
      this.ruleForm.organizations = numberArray
    },
  },
}
</script>
